var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"hide-file-input",attrs:{"id":"file-input","type":"file","accept":"image/*"},on:{"change":function($event){return _vm.onFileChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }